import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Search } from "lucide-react";
import { useInstrumentsController } from "./useInstrumentsController";
import InstrumentAvatar from "./components/InstrumentAvatar";
import { ImportButton } from "../imports/components";
export const Instruments = () => {
  const controller = useInstrumentsController();

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Instruments</h1>
        <ImportButton context="instrument" />
      </div>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Instruments Management</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4 mb-4">
            <div className="relative flex-1">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search instruments..."
                className="pl-8"
                value={controller.searchQuery}
                onChange={(e) => controller.setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="max-h-[80vh] overflow-auto">
            <Table>
              <TableHeader className="sticky top-0 bg-background z-10">
                <TableRow>
                  <TableHead className="w-12"></TableHead>
                  <TableHead>Key</TableHead>
                  <TableHead>Name</TableHead>
                  <TableHead>Type</TableHead>
                  <TableHead>Class</TableHead>
                  <TableHead>Round</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {controller.isLoading ? (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-4">
                      Loading instruments...
                    </TableCell>
                  </TableRow>
                ) : controller.filteredInstruments.length > 0 ? (
                  controller.filteredInstruments.map((instrument) => (
                    <TableRow key={instrument.instrumentKey}>
                      <TableCell>
                        <InstrumentAvatar
                          instrumentKey={instrument.instrumentKey}
                          name={instrument.name}
                          size="sm"
                        />
                      </TableCell>
                      <TableCell>{instrument.instrumentKey}</TableCell>
                      <TableCell className="font-medium">
                        {instrument.name}
                      </TableCell>
                      <TableCell className="font-medium">
                        {instrument.instrumentType}
                      </TableCell>
                      <TableCell className="font-medium">
                        {instrument.instrumentClass}
                      </TableCell>
                      <TableCell className="font-medium">
                        {instrument.round}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-4">
                      No instruments found matching your search.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
